"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
/**
 * Creates an `image` content model
 *
 * @param {object} entity - The Contentful entry / asset
 * @param {object} entity.sys - The sys properties for the entry
 * @param {object} entity.sys.id - The unique id for the entry
 * @param {object} entity.fields - The fields on the entry
 * @param {string} entity.fields.title - The image title
 * @param {string} entity.fields.description - The image description, this is used for the alt text
 * @param {string} entity.fields.url - The Contentful URL for the image
 * @param {object} entity.fields.file - Image file metadata
 * @param {object} entity.fields.details - Details about the asset
 * @param {object} entity.fields.details.image - Details about the image
 * @param {string} entity.fields.file.details.image.width - The width of the image
 * @param {string} entity.fields.file.details.image.height - The height of the image
 * @returns {object} `image` content model
 */
var createImage = function createImage(_ref) {
  var _fields$file, _fields$file$details, _fields$file2, _fields$file2$details;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    title: (0, _utils.getProp)(fields, 'title'),
    description: (0, _utils.getProp)(fields, 'description'),
    src: fields !== null && fields !== void 0 && fields.file ? (0, _utils.getProp)(fields.file, 'url') : null,
    mimeType: fields !== null && fields !== void 0 && fields.file ? (0, _utils.getProp)(fields.file, 'contentType') : null,
    srcWidth: fields !== null && fields !== void 0 && fields.file ? (0, _utils.getProp)((_fields$file = fields.file) === null || _fields$file === void 0 ? void 0 : (_fields$file$details = _fields$file.details) === null || _fields$file$details === void 0 ? void 0 : _fields$file$details.image, 'width') : null,
    srcHeight: fields !== null && fields !== void 0 && fields.file ? (0, _utils.getProp)((_fields$file2 = fields.file) === null || _fields$file2 === void 0 ? void 0 : (_fields$file2$details = _fields$file2.details) === null || _fields$file2$details === void 0 ? void 0 : _fields$file2$details.image, 'height') : null
  };
};
var _default = createImage;
exports["default"] = _default;